import { Controller } from "@hotwired/stimulus";

// A form that posts itself. Two modes, one name (fire owns it):
//
//   change   data-action="change->autosubmit#submit": a select or checkbox
//            with no button (um's topic, nbe's cow bench).
//   connect  data-autosubmit-now-value="true": posts once, when the page is
//            really up: /phone's own ask for the SMS code (docs/DOORS.md
//            § A typed number waits). A GET never sends, so the ask rides here.
//            Never from Turbo's preview of a cached page; the form is
//            data-turbo-temporary, and the server sends nothing while a code is live.
//
// Without the value, a loaded page submits nothing.
export default class extends Controller {
  static values = { now: Boolean };

  connect() {
    if (!this.nowValue) return;
    if (document.documentElement.hasAttribute("data-turbo-preview")) return;
    this.submit();
  }

  submit() {
    this.element.requestSubmit();
  }
}
